import DetailDataSection from './DetailDataSection';

export default DetailDataSection;
